import "./App.scss";
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home/Home";
import { createTheme, ThemeProvider  } from "@mui/material/styles";
import { AppContext } from "./Context/AppContext";
import axios from "axios";
import './css/global.css'

import Header from "./Components/common/header";
import Footer from "./Components/common/footer";

let theme = createTheme({
  palette: {
    primary: {
      main: "#2b6777",
    },
    secondary: {
      main: "#52ab98",
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
});


function App() {
  const [screensData, setScreensData] = useState({
    screen1: {
      year: "",
      make: "",
      model: "",
      vin: "",
      vinDecodedDetails: {},
      yearError: false,
      makeError: false,
      modelError: false,
      vinError: false,
      makes: [],
      models: [],
    },
    screen1_1:{
      make: "",
    },
    screen1_2:{
      model: "",
    },
    screen2: {
      trim: "",
      trimError: false,
      trims: [],
    },
    screen3: {
      title: "",
      owner: "",
      titleError: false,
      ownerError: false,
    },
    screen4: {
      vin: "",
      vinError: false,
    },
    screen5: {
      wheels: "",
      wheelsError: false,
    },
    screen6: {
      key: "",
      keyError: false,
    },
    screen7: {
      engineTransmission: "",
      engineTransmissionError: false,
    },
    screen8: {
      catalyticConverter: "",
      catalyticConverterError: false,
    },
    screen9: {
      firstName: "",
      phone: "",
      email: "",
      firstNameError: false,
      phoneError: false,
      emailError: false,
    },
    screen10: {
      offeredPrice: 0,
    },
    screen11: {
      firstName: "",
      lastName: "",
      phone: "",
      firstNameError: false,
      lastNameError: false,
      phoneError: false,
    },
    screen12: {
      address: "",
      city: "",
      state: "",
      zipCode: "",
      addressError: false,
      cityError: false,
      stateError: false,
      zipCodeError: false,
    },
    screen13: {
      date: new Date(),
      time: new Date(),
      dateError: false,
      timeError: false,
    },
    offerId: null,
  });
  const baseUrl = (/local/.test(window.location.href) ? "http://localhost:3002": "https://secure-temple-73063.herokuapp.com") || "https://carcalculator.herokuapp.com";

  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return variable;
  }

  useEffect(() => {
    axios.get(`${baseUrl}/ping`).then((res) => { });
    if (getQueryVariable("type") === "accept") {
      screensData.offerId = getQueryVariable("offer_token");
      setActiveScreen(11);
    }
  }, []);

  const [showSpinner, setShowSpinner] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [activeScreen, setActiveScreen] = useState(0);
  const [activeFocus, setActiveFocus] = useState("year");
  const [offeredPrice, setOfferedPrice] = useState(0);

  return (

      <ThemeProvider theme={theme}>
        <Header/>
        <AppContext.Provider
            value={{
              screensData,
              setScreensData,
              activeScreen,
              setActiveScreen,
              showSnackbar,
              setShowSnackbar,
              snackbarMessage,
              setSnackbarMessage,
              showSpinner,
              setShowSpinner,
              activeFocus,
              setActiveFocus,
              offeredPrice,
              setOfferedPrice,
            }}
        >
          <div className="main center">

            <Router>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/sell" element={<Home />} />
              </Routes>
            </Router>
          </div>
        </AppContext.Provider>
        <Footer/>
      </ThemeProvider>
  );
}

export default App;
